import * as React from 'react';
import { MaskedTextBox } from '@progress/kendo-react-inputs';
import { RouteComponentProps, Prompt } from 'react-router-dom';
import { fetchApi } from '../../services/api';
import StreetAddress, { StreetAddressViewModel } from '../StreetAddress';
import WeightInput from '../WeightInput';
import LengthInput from '../LengthInput';
import LoadingButton from '../LoadingButton';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{
    childId: string
}>

type State = {
    medical: MedicalData|undefined;
    isLoading: boolean;
    isDirty: boolean;
    Validation: boolean;
    childId: number;
}

export type MedicalData = {
    DoctorFirstName: string;
    DoctorLastName: string;
    DoctorPhone: string;
    DoctorAddress: StreetAddressViewModel | null;
    Healthcard: string;
    Height: number;
    HeightUnitOfMeasure: number;
    Weight: number;
    WeightUnitOfMeasure: number;
    Disability: string;
    Chronic: string;
    Disorder: string;
    Medication: string;
    Allergies: string;
    Dietary: string;
    Other: string;
    HasDisability: boolean;
    HasChronic: boolean;
    HasDisorder: boolean;
    HasMedication: boolean;
    HasAllergies: boolean;
    HasDietary: boolean;
    HasMeasles: boolean;
    HasChickenPox: boolean;
    HasScarletFever: boolean;
    HasGermanMeasles: boolean;
    HasWhoopingCough: boolean;
    HasOther: boolean;
}

export default class Medical extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            childId: 0,
            medical: undefined,
            isLoading: false,
            isDirty: false,
            Validation: false,
        }

        this.save = this.save.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let childId = parseInt(this.props.match.params.childId) || 0;
        this.requestMedical(childId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let childId = parseInt(nextProps.match.params.childId) || 0;

        if (this.state.medical && this.state.childId != childId) {
            this.requestMedical(childId);
        }
    }

    public render() {
        return <div>
            <br/>
            {this.state.medical && <div className="k-form">
                <DocumentTitle title="Medical" />
                <Prompt when={this.state.isDirty} message="Unsaved changes will be lost, are you sure?" />
                {this.state.isLoading && <div className="k-loading-image"></div>}
                <h5>Medical Information</h5>
                <div className="card">
                    <div className="card-body">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Health Card Number<div style={{ color: '#dc3545' }}>*</div></span>
                            </div>
                            <MaskedTextBox
                                mask="0000-000-000-LL"
                                name={`Healthcard`}
                                placeholder="0000-000-000-AA"
                                value={this.state.medical.Healthcard}
                                onChange={(e) => this.updateMedicalState({ Healthcard: e.target.value.replace(/_/g, "") })}
                            />
                        </div>
                        {(this.state.Validation && (!this.state.medical.Healthcard || this.state.medical.Healthcard.length < 15)) ? <p className="error-msg">Health Card is Required</p> : <br/>}
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Height</span>
                            </div>
                            <LengthInput type={this.state.medical.HeightUnitOfMeasure} value={this.state.medical.Height} onChange={(value) => this.updateMedicalState({ Height: value.value, HeightUnitOfMeasure: value.type })} />
                        </div>
                        <br/>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">Weight</span>
                            </div>
                            <WeightInput type={this.state.medical.WeightUnitOfMeasure} value={this.state.medical.Weight} onChange={(value) => this.updateMedicalState({ Weight: value.value, WeightUnitOfMeasure: value.type })} />
                        </div>
                        <br/>
                        <div className="form-group">
                            <h6>Does the child have</h6>
                            <br/>
                            <label className="k-form-field">
                                <input type="checkbox" id="disability" className="k-checkbox" checked={this.state.medical.HasDisability} onChange={(e) => this.updateMedicalState({HasDisability: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="disability">Phyiscal Disabilities?</label>
                            </label>
                            {this.state.medical.HasDisability &&
                            <textarea
                                name="Disability"
                                className="form-control"
                                placeholder="Please Describe"
                                value={this.state.medical.Disability}
                                onChange={(e) => this.updateMedicalState({ Disability: e.target.value })}
                            />}
                            <br/>
                            <label className="k-form-field">
                                <input type="checkbox" id="chronic" className="k-checkbox" checked={this.state.medical.HasChronic} onChange={(e) => this.updateMedicalState({HasChronic: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="chronic">Chronic Health Problems?</label>
                            </label>
                            {this.state.medical.HasChronic &&
                            <textarea
                                name="Chronic"
                                className="form-control"
                                placeholder="Please Describe"
                                value={this.state.medical.Chronic}
                                onChange={(e) => this.updateMedicalState({ Chronic: e.target.value })}
                            />}
                            <br/>
                            <label className="k-form-field">
                                <input type="checkbox" id="disorder" className="k-checkbox" checked={this.state.medical.HasDisorder} onChange={(e) => this.updateMedicalState({HasDisorder: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="disorder">Emotional Disorders or Behavioral Problems?</label>
                            </label>
                            {this.state.medical.HasDisorder &&
                            <textarea
                                name="Disorder"
                                className="form-control"
                                placeholder="Please Describe"
                                value={this.state.medical.Disorder}
                                onChange={(e) => this.updateMedicalState({ Disorder: e.target.value })}
                            />}
                            <br/>
                            <label className="k-form-field">
                                <input type="checkbox" id="medication" className="k-checkbox" checked={this.state.medical.HasMedication} onChange={(e) => this.updateMedicalState({HasMedication: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="medication">Medications?</label>
                            </label>
                            {this.state.medical.HasMedication &&
                            <textarea
                                name="Medication"
                                className="form-control"
                                placeholder="Please Describe"
                                value={this.state.medical.Medication}
                                onChange={(e) => this.updateMedicalState({ Medication: e.target.value })}
                            />}
                            <br/>
                            <label className="k-form-field">
                                <input type="checkbox" id="allergies" className="k-checkbox" checked={this.state.medical.HasAllergies} onChange={(e) => this.updateMedicalState({HasAllergies: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="allergies">Allergies?</label>
                            </label>
                            {this.state.medical.HasAllergies &&
                            <textarea
                                name="Allergies"
                                className="form-control"
                                placeholder="Please Describe"
                                value={this.state.medical.Allergies}
                                onChange={(e) => this.updateMedicalState({ Allergies: e.target.value })}
                            />}
                            <br/>
                            <label className="k-form-field">
                                <input type="checkbox" id="dietary" className="k-checkbox" checked={this.state.medical.HasDietary} onChange={(e) => this.updateMedicalState({HasDietary: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="dietary">Dietary Restrictions?</label>
                            </label>
                            {this.state.medical.HasDietary &&
                            <textarea
                                name="Dietary"
                                className="form-control"
                                placeholder="Please Describe"
                                value={this.state.medical.Dietary}
                                onChange={(e) => this.updateMedicalState({ Dietary: e.target.value })}
                            />}
                            <br/>
                            <br/>
                            <h6>Has the child ever had any of these communicable diseases?</h6>
                            <br/>
                            <label className="k-form-field">
                                <input type="checkbox" id="measles" className="k-checkbox" checked={this.state.medical.HasMeasles} onChange={(e) => this.updateMedicalState({HasMeasles: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="measles">Measles</label>
                            </label>
                            <br/>
                            <label className="k-form-field">
                                <input type="checkbox" id="chickenPox" className="k-checkbox" checked={this.state.medical.HasChickenPox} onChange={(e) => this.updateMedicalState({HasChickenPox: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="chickenPox">Chicken Pox</label>
                            </label>
                            <br/>
                            <label className="k-form-field">
                                <input type="checkbox" id="scarletFever" className="k-checkbox" checked={this.state.medical.HasScarletFever} onChange={(e) => this.updateMedicalState({HasScarletFever: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="scarletFever">Scarlet Fever</label>
                            </label>
                            <br/>
                            <label className="k-form-field">
                                <input type="checkbox" id="germanMeasles" className="k-checkbox" checked={this.state.medical.HasGermanMeasles} onChange={(e) => this.updateMedicalState({HasGermanMeasles: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="germanMeasles">German Measles</label>
                            </label>
                            <br/>
                            <label className="k-form-field">
                                <input type="checkbox" id="whoopingCough" className="k-checkbox" checked={this.state.medical.HasWhoopingCough} onChange={(e) => this.updateMedicalState({HasWhoopingCough: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="whoopingCough">Whooping Cough</label>
                            </label>
                            <br/>
                            <label className="k-form-field">
                                <input type="checkbox" id="other" className="k-checkbox" checked={this.state.medical.HasOther} onChange={(e) => this.updateMedicalState({HasOther: e.target.checked})}/>
                                <label className="k-checkbox-label" htmlFor="other">Other</label>
                            </label>
                            <br/>
                            {this.state.medical.HasOther &&
                            <textarea
                                name="Other"
                                className="form-control"
                                placeholder="Please Describe"
                                value={this.state.medical.Other}
                                onChange={(e) => this.updateMedicalState({ Other: e.target.value })}
                            />}
                        </div>
                        <br/>
                        <h5>Doctor's Information</h5>
                        <br/>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">First and Last Name<div style={{ color: '#dc3545' }}>*</div></span>
                            </div>
                            <input
                                type="text"
                                placeholder="First Name"
                                className="form-control"
                                value={this.state.medical.DoctorFirstName}
                                onChange={(e) => this.updateMedicalState({ DoctorFirstName: e.target.value })}
                            />
                            <input
                                type="text"
                                placeholder="Last Name"
                                className="form-control"
                                value={this.state.medical.DoctorLastName}
                                onChange={(e) => this.updateMedicalState({ DoctorLastName: e.target.value })}
                            />
                        </div>
                        {this.state.Validation && !this.state.medical.DoctorFirstName && !this.state.medical.DoctorLastName && <p style={{ color: '#dc3545' }}>First and Last Name are Required</p>}
                        {this.state.Validation && !this.state.medical.DoctorFirstName && this.state.medical.DoctorLastName && <p style={{ color: '#dc3545' }}>First Name is Required</p>}
                        {this.state.Validation && this.state.medical.DoctorFirstName && !this.state.medical.DoctorLastName && <p style={{ color: '#dc3545' }}>Last Name is Required</p>}
                        {this.state.Validation && this.state.medical.DoctorFirstName && this.state.medical.DoctorLastName && <br/> || !this.state.Validation && <br/>}
                        <label>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">Phone Number<div style={{ color: '#dc3545' }}>*</div></span>
                                </div>
                                <MaskedTextBox
                                    mask="(000)000-0000"
                                    name="Phone"
                                    placeholder="(000)000-0000"
                                    value={this.state.medical.DoctorPhone || ''}
                                    onChange={(e) => this.updateMedicalState({ DoctorPhone: e.target.value.replace(/_/g, "") })}
                                />
                            </div>
                        </label>
                        <br/>
                        {(this.state.Validation && (!this.state.medical.DoctorPhone || this.state.medical.DoctorPhone.length < 13)) ? <p className="error-msg">Phone Number is Required</p> : <br/>}
                        <StreetAddress
                            address={this.state.medical.DoctorAddress}
                            onChange={(newAddress) => this.updateMedicalState({ DoctorAddress: newAddress })}
                            title="Clinic Address"
                            validation={this.state.Validation}
                        />
                    </div>
                </div>
                <br/>
                <LoadingButton 
                    onClick={this.save}
                    disabled={!this.state.isDirty}
                    isLoading={this.state.isLoading}
                    isLoadingText="Saving..."
                    className="btn btn-primary"
                >
                    Save
                </LoadingButton>
            </div>}
            <br/>
            <br/>
        </div>
    }

    private save(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();
        this.setState({ Validation: true}, () => {
            if (this.state.medical && document.getElementsByClassName("error-msg").length === 0) {
                this.setState({ isLoading: true });
                fetchApi(`api/ChildMedical/Save/${this.state.childId}`, this.state.medical, 'POST')
                    .then((response: { Message: string, Errors: Array<{ Field: string, Message: string }> }) => {
                        if (!response.Errors)
                        {
                            this.setState({ isDirty: false });
                        }
                    }).catch((error: Error) => {
                        alert("Unknown Error Occurred!");
                    }).finally(() => {
                        this.setState({ isLoading: false });
                    });
            } else {
                document.getElementsByClassName("error-msg")[0].scrollIntoView({ block: "center" });
            }
        });

    }

    private requestMedical(childId: number) {
        this.setState({ isLoading: true, childId });
        fetchApi(`api/ChildMedical/Get/${childId}`)
            .then((medical: MedicalData) => {
                this.setState({ isLoading: false, isDirty: false, medical });
            });
    }

    private updateMedicalState(value: Object|MedicalData) {
        const medical = Object.assign({}, this.state.medical, value);
        this.setState({ medical, isDirty: true });
    }
}
